module.exports = __webpack_public_path__ + "static/media/43.78d69015.svg";